import React from 'react';
import PropTypes from 'prop-types';
import Select from 'antd/lib/select';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;

export const CATEGORIES = [
  {
    key: 'Headshots',
    label: 'Headshots',
  },
  {
    key: 'Family Portraits',
    label: 'Family Portraits',
  },
  {
    key: 'Newborn',
    label: 'Newborn',
  },
  {
    key: 'Senior Portraits',
    label: 'Senior Portraits',
  },
  {
    key: 'Uncategorized',
    label: 'Uncategorized',
  },
  {
    key: 'Wedding',
    label: 'Wedding',
  },
  {
    key: 'Events',
    label: 'Events',
  },
  {
    key: 'Commercial',
    label: 'Commercial',
  },
  {
    key: 'Boudoir',
    label: 'Boudoir',
  },
];

// EXPORTED COMPONENT
// ================================================================
class SelectQuestionCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || [], // array of selected values [{ key, label }, ...]
      data: CATEGORIES, //[], // array of options to be displayed when searching [{ key, label }, ...]
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleSearch(value) {
    // Look for categories matching user's input (value)
    const data = !value ? CATEGORIES : CATEGORIES.filter(({ label }) => new RegExp(value, 'i').test(label));
    this.setState({ data });
  }

  handleChange(value) {
    // Once an option from the dropdown is selected, clear list of options
    this.setState({ value, data: CATEGORIES });
    this.props.onChange({ categories: value });
  }

  render() {
    const { value, data } = this.state;

    return (
      <Select
        mode="multiple"
        labelInValue
        value={value}
        size="large"
        searchPlaceholder="Enter Category"
        notFoundContent={null}
        filterOption={false}
        onSearch={this.handleSearch}
        onChange={this.handleChange}
        style={{ width: '100%', fontSize: '16px' }}
      >
        {data.map(d => (
          <Option key={d.key}>{d.label}</Option>
        ))}
      </Select>
    );
  }
}

SelectQuestionCategory.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
};

SelectQuestionCategory.defaultProps = {
  value: [],
  onChange: () => {},
};

// EXPORT
// ================================================================
export default SelectQuestionCategory;



// WEBPACK FOOTER //
// ./src/components/inputs/SelectQuestionCategory/index.js